import { render, staticRenderFns } from "./UploadedFilesModal.vue?vue&type=template&id=7551515a&"
import script from "./UploadedFilesModal.vue?vue&type=script&lang=js&"
export * from "./UploadedFilesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports